import { Metadata } from "../core/components/commonApp.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { DropDownList, DropDownListField, DropDownListProps } from "../core/components/dropDownList.js";
import { FieldInstance } from "../core/components/field.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react";
import ReactDOM from "react-dom";

export const OpenTicketChangeStateDialog = (entity: any, externalStatusDependsOnTicketType: boolean) => {
    return new Promise<boolean>((resolve) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: TicketChangeStateDialogProps = {
            onOk: () => {
                resolve(true);
            },
            onCancel: () => {
                resolve(false);
                root.unmount();
            },
            entity: entity,
            externalStatusDependsOnTicketType: externalStatusDependsOnTicketType
        }
        $("body").append(targetElement);
        root.render(<TicketChangeStateDialog {...props} />);
    })
}

interface TicketChangeStateDialogProps {
    onOk: () => void;
    entity: {
        proStatusKey?: number;
        vorgangstyp_Key: number;
        problemNr: number;
    },
    onCancel: () => void;
    externalStatusDependsOnTicketType: boolean;
}

class TicketChangeStateDialog extends React.Component<TicketChangeStateDialogProps, {
    proStatusKey: number,
    dropDownMetaData: any
}>{
    private factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props)
        this.state = {
            proStatusKey: this.props.entity.proStatusKey,
            dropDownMetaData: []
        }
    }

    async componentDidMount() {
        let result = await HTTPService.chainBatch
            .add<Metadata>(Helper.getMetaData("procedureForward"))
            .promise();
        let metaData = result[0];
        
        let dropDownMetaData: DropDownListField = MetaDataHelper.getFieldByProperty(metaData, "model", "entity.Vorgangsstatus_Key");

        if (this.props.externalStatusDependsOnTicketType)
            dropDownMetaData.dataSourceUrl = "ProcedureLookup/GetStatus?pkey=" + encodeURI(this.props.entity.vorgangstyp_Key.toString());

        this.setState({ proStatusKey: this.props.entity.proStatusKey, dropDownMetaData: dropDownMetaData });
    }

    private forwardProcedure = async () => {
        let forwardData = { Vorgangsstatus_Key: this.state.proStatusKey, ProblemNr: this.props.entity.problemNr, OnlyChangeState: true };
        let result = await HTTPService.post<JsonResultClass>("Procedure/Forward", forwardData);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Field.Vorgang.TicketStateSuccesfullyChanged"));
            this.props.onOk();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private getDialogProps = () => {
        let dialogProps: DialogProps = {
            title: Helper.getTranslation("Field.Vorgang.ChangeTicketSate"),
            actions: [
                {
                    label: Config.translations.cancel,
                    action: this.props.onCancel
                },
                {
                    label: Config.translations.ok,
                    action: () => {
                        if (this.state.proStatusKey == null || this.state.proStatusKey == 0) {
                            DialogHelper.alert(Helper.getTranslation("Field.Vorgang.TicketstateMustFilled"));
                            return false;
                        }
                        else if (this.state.proStatusKey != this.props.entity.proStatusKey) {
                            this.forwardProcedure();
                        }
                        else {
                            this.props.onOk();
                        }
                    },
                    primary: true
                }
            ],
            afterClose: () => {
            },
            width: 500
        };
        return dialogProps;
    }

    private getDropDownProps = () => {
        let metaData = this.state.dropDownMetaData;
        let props: DropDownListProps = this.factory.getDefaultDropDownProps();
        props.field = metaData;
        props.field.required = true;
        props.value = this.state.proStatusKey;
        props.onChange = (_, value) => {
            this.setState({ proStatusKey: value });
        };
        props.field.dataValueField = "ProStatusKey";
        props.field.dataTextField = "Beschreibung";
        return props;
    }

    private createDialog = () => {
        let dropDownProps = this.getDropDownProps();
        let dialogProps = this.getDialogProps();

        return (
            <Dialog {...dialogProps} open={true}>
                <FieldInstance label={Helper.getTranslation("Field.Vorgang.vorgangsstatus")}>
                    <DropDownList {...dropDownProps} />
                </FieldInstance>
            </Dialog>
        );
    }

    render() {
        return this.createDialog();
    }
}